import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "../chunk-MQXBDTVK.js"; // src/providers/jsonRpc.ts

import { providers } from "ethers";

function jsonRpcProvider(_ref) {
  var priority = _ref.priority,
      rpc = _ref.rpc,
      stallTimeout = _ref.stallTimeout,
      _ref$static = _ref.static,
      static_ = _ref$static === void 0 ? true : _ref$static,
      weight = _ref.weight;
  return function (chain) {
    var rpcConfig = rpc(chain);
    if (!rpcConfig || rpcConfig.http === "") return null;
    return _objectSpread({
      chain: _objectSpread(_objectSpread({}, chain), {}, {
        rpcUrls: _objectSpread(_objectSpread({}, chain.rpcUrls), {}, {
          default: {
            http: [rpcConfig.http]
          }
        })
      }),
      provider: function provider() {
        var _chain$contracts, _chain$contracts$ensR;

        var RpcProvider = static_ ? providers.StaticJsonRpcProvider : providers.JsonRpcProvider;
        var provider = new RpcProvider(rpcConfig.http, {
          ensAddress: (_chain$contracts = chain.contracts) === null || _chain$contracts === void 0 ? void 0 : (_chain$contracts$ensR = _chain$contracts.ensRegistry) === null || _chain$contracts$ensR === void 0 ? void 0 : _chain$contracts$ensR.address,
          chainId: chain.id,
          name: chain.network
        });
        return Object.assign(provider, {
          priority: priority,
          stallTimeout: stallTimeout,
          weight: weight
        });
      }
    }, rpcConfig.webSocket && {
      webSocketProvider: function webSocketProvider() {
        return new providers.WebSocketProvider(rpcConfig.webSocket, chain.id);
      }
    });
  };
}

export { jsonRpcProvider };